export const StepIdle = 'Idle';
export const StepBoxReveal = 'BoxReveal';
export const StepPackReveal = 'PackReveal';
export const StepGoldenTicketReveal = 'GoldenTicketReveal';
export const StepGoldenTicketResult = 'GoldenTicketResult';
export const StepCardsReveal = 'CardsReveal';
export const StepTicketReveal = 'TicketReveal';
